import { CommandMethods } from 'types/CommandMethods';
export class AttendantPermissionService {
    static $inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
    constructor(MessagingHubService, MESSAGINGHUBDOMAIN) {
        this.MessagingHubService = MessagingHubService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
    }
    async setAttendantPermissions(attendantIdentity, permissions) {
        return await this.MessagingHubService.sendCommandSafe({
            method: CommandMethods.set,
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            type: 'application/vnd.lime.collection+json',
            uri: `/agent/${encodeURIComponent(attendantIdentity)}/permission`,
            resource: {
                itemType: 'application/vnd.iris.desk.agentpermission+json',
                items: permissions,
            },
        });
    }
    async setAttendantsPermissions(attendants, permissions) {
        return await this.MessagingHubService.sendCommandSafe({
            method: CommandMethods.set,
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            type: 'application/vnd.lime.collection+json',
            uri: '/agent/permissions',
            resource: {
                itemType: 'application/vnd.iris.desk.agentspermissions+json',
                items: [
                    {
                        agents: attendants,
                        permissions: permissions,
                    },
                ],
            },
        });
    }
    async getAttendantPermissions(attendantIdentity) {
        return await this.MessagingHubService.sendCommandSafe({
            method: CommandMethods.get,
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/agent/${encodeURIComponent(attendantIdentity)}/permission`,
        });
    }
    async getAvailableAttendantPermissions() {
        return await this.MessagingHubService.sendCommandSafe({
            method: CommandMethods.get,
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: '/agent/permissions/available',
        });
    }
}
AttendantPermissionService.$inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
